<template>
    <div>
        <div class="container is-max-desktop p-5">
            <LoginHeader/>
            <div class="columns">
                <div class="column">
                    <div class="content">
                    <img v-if="sendResetLinkSuccess" :src="resetLinkSentUrl">
                    <img v-else :src="forgotPasswordUrl">
                    </div>
                </div>
                <div class="column" v-if="sendResetLinkSuccess">
                    <div class="card">
                        <p class="card-header-title pl-5">
                            {{$t('reset_link_send_is_success')}}
                        </p>
                        <div class="card-content has-text-left">
                            <p class="mb-5">{{$t('send_reset_password_success_info_text')}}</p>
                            <div class="columns">
                                <div class="column is-flex is-align-items-center">
                                    <router-link to="login" custom v-slot="{navigate}">
                                        <a @click="navigate" role="link"><b-icon size="is-small" icon="arrow-left"></b-icon> {{$t('login')}}</a>
                                    </router-link>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                <div class="column" v-else>
                    <div class="card">
                    <p class="card-header-title pl-5">
                        {{$t('forgot_password')}}
                    </p>
                    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <div class="card-content has-text-left">
                        <p class="mb-5">{{$t('reset_password_info_text')}}</p>
                        <ValidationProvider rules="requiredEmail|validEmail" v-slot="{ errors }">
                        <b-field :label="labels.email.show?$t('email'):''" :label-position="labels.email.position" class="mb-5"
                        :type="{'is-danger':errors[0]}"
                        :message="[$t(errors[0])]">
                            <b-input :placeholder="$t('email')+'*'" @keyup.enter.native="handleSubmit(requestPasswordResetF)" v-model.trim="form.email" @focus="focusInput('email')" @blur="blurInput('email')"></b-input>                  
                        </b-field>
                        </ValidationProvider>
                        <div class="columns">
                        <div class="column is-flex is-align-items-center is-justify-content-space-between">
                            <b-button type="is-primary" @click="handleSubmit(requestPasswordResetF)">{{$t('send_reset_password_request')}}</b-button>
                            <router-link to="/login" custom v-slot="{ navigate }">
                                <a @click="navigate" role="link"><b-icon size="is-small" icon="arrow-left"></b-icon> {{$t('go_back')}}</a>
                            </router-link>
                        </div>
                        </div>  
                    </div>
                    </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import LoginHeader from './LoginHeader';

extend('requiredEmail', {
  ...required,
  message: 'email_is_required'
});

extend('validEmail',{
  ...email,
  message : 'please_enter_a_valid_email'
});

export default {
    name:"ForgotPassword",
    components: {
        LoginHeader,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            forgotPasswordUrl:"/static/images/ForgotPassword.svg",
            resetLinkSentUrl:"/static/images/ResetLinkSent.svg",
            form:{
                email:''
            },
            labels:{
                email:{position:'',show:false}
            },
            sendResetLinkSuccess:false
        }
    },
    methods: {
        ...mapActions(['requestPasswordReset']),
        focusInput(val){
            this.labels[val].position='on-border'
            this.labels[val].show=true
        },
        blurInput(val){
            if(this.form[val]==''){
                this.labels[val].show=false
            }
        },
        requestPasswordResetF(){
            this.requestPasswordReset(this.form).then((response) => {
                console.log('--requestPasswordReset success response')
                console.log(response)
                if(response.status.code=='0'){
                    this.sendResetLinkSuccess=true
                }
            }).catch(e => {
                console.log("--requestPasswordReset Error")
                console.log(e)
            })
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/ForgotPassword.vue